// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconGamingPath = 'M4.797 3.018a4 4 0 0 1 4.07 2.383h2.266A4 4 0 0 1 18.8 6.92l1.155 7.438a2.2 2.2 0 0 1-3.253 2.35l-.02-.011-5.173-3.294H8.49l-5.173 3.294-.02.01a2.2 2.2 0 0 1-3.253-2.349L1.2 6.919a4 4 0 0 1 3.597-3.9Zm1.589 2.37A2 2 0 0 0 3.199 7v.078l-1.187 7.646-.007.033a.2.2 0 0 0 .284.223l5.62-3.578h4.183l5.62 3.578a.2.2 0 0 0 .283-.223l-.007-.033L16.8 7.078V7a2 2 0 0 0-3.96-.4l-.163.801H7.322l-.162-.8a2 2 0 0 0-.774-1.213ZM5.3 10.002v-.7h-.7v-1h.7v-.7h1v.7H7v1h-.7v.7h-1Zm8.959-.293a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z';
var IconGaming = baseIcon('IconGaming', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconGamingPath
});
export default IconGaming;
//# sourceMappingURL=index.js.map